import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import MultiAccountsContext from './MultiAccountsContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const MultiAccountsProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <MultiAccountsContext.Provider value={{ actions, selectors, state }}>
      {children}
    </MultiAccountsContext.Provider>
  );
};

export default MultiAccountsProvider;
